module.exports = __webpack_public_path__ + "img/user.3abc90ea.svg";